import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {
  useRecoilRefresher_UNSTABLE,
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import { Close, Search } from "@mui/icons-material";
import { Grid, Stack, Typography } from "@mui/material";
import { showModalEditFiltersState } from "../../../store/reservation/reservationState";
import ButtonCustom from "../../../shared/components/buttons/ButtonCustom";
import ModalTitleCustom from "../../../shared/components/modals/ModalTitle";
import FormSearch from "src/SearchHours/FormSearch";
import useSearchHours from "src/SearchHours/hooks/useSearchHours";
import AlertCustom from "src/shared/components/alerts/AlertCustom";
import { yellow } from "@mui/material/colors";
import { historyRouteState } from "src/store/global/historyState";
import { dayDefaultAvailableState } from "../calendars/state/atoms";
import {
  dayAvailableDefaultFetchState,
  daysAvailableFetchState,
  filterSearchSelectedState,
  hoursAvailableFetchState,
  hoursAvailableState,
  isChangeFormSearchState,
  professionalsMatchCovenantState,
  professionalsNoMatchCovenantState,
} from "src/SearchHours/state/atoms";
import ManageStorage from "src/shared/global/manageStorage";
//import ReactGA from 'react-ga';
import ReactGA from "react-ga4";
import { agendamientoInconclusoState } from "src/ResultSearch/state/atoms";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function ModalEditFilters() {
  const isChangeFormSearch = useRecoilValue(isChangeFormSearchState);
  const [showModalEditFilters, setShowModalEditFilters] = useRecoilState(
    showModalEditFiltersState
  );
  const [loading, setLoading] = useState(false);
  const { isEmptyFilters, loadDaysAvailableAndDefault, loadHoursAvailable } =
    useSearchHours();
  const historyRoute = useRecoilValue(historyRouteState);
  const resetDayDefaultAvailable = useResetRecoilState(
    dayDefaultAvailableState
  );
  //const resetHoursAvailable = useResetRecoilState(hoursAvailableState);
  const dayDefaultAvailable = useRecoilValue(dayDefaultAvailableState);
  const filterSearchSelected = useRecoilValue(filterSearchSelectedState);
  const refreshHours = useRecoilRefresher_UNSTABLE(hoursAvailableFetchState);
  const refreshDayAvailableDefault = useRecoilRefresher_UNSTABLE(
    dayAvailableDefaultFetchState
  );
  const refreshDaysAvailable = useRecoilRefresher_UNSTABLE(
    daysAvailableFetchState
  );
  const resetProfessionalsMatchCovenant = useResetRecoilState(
    professionalsMatchCovenantState
  );
  const resetProfessionalsNoMatchCovenant = useResetRecoilState(
    professionalsNoMatchCovenantState
  );
  const resetHoursAvailable = useResetRecoilState(hoursAvailableState);

  const handleClose = (ev, reason) => {
    if (reason && reason === "backdropClick") return;

    if (historyRoute.location.pathname.includes("/resultado-busqueda")) return;
    setShowModalEditFilters(false);
  };

  const setValueAgendamientoInconcluso = useSetRecoilState(
    agendamientoInconclusoState
  );

  useEffect(() => {
    return () => {
      setShowModalEditFilters(false);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleEditFilters = () => {
    setLoading(true);
    eventGA();
    setTimeout(async () => {
      resetProfessionalsMatchCovenant();
      resetProfessionalsNoMatchCovenant();
      resetHoursAvailable();
      try {
        if (
          !ManageStorage.getValueFromStorage("currentUrl").includes(
            "/resultado-busqueda"
          )
        ) {
          resetDayDefaultAvailable();
          refreshHours();
          historyRoute.push(
            `${process.env.REACT_APP_ROOT_SERVER_PATH}/resultado-busqueda`
          );
        } else {
          if (
            filterSearchSelected.specialitySelected.value !== "" &&
            filterSearchSelected.professionalSelected.value !== "" &&
            filterSearchSelected.covenantSelected.value !== ""
          ) {
            resetDayDefaultAvailable();
            await loadDaysAvailableAndDefault();
          } else {
            if (
              filterSearchSelected.covenantSelected.value !== "" &&
              ManageStorage.getValueFromStorage("currentUrl").includes(
                "/resultado-busqueda"
              )
            ) {
              if (!dayDefaultAvailable) {
                resetDayDefaultAvailable();
                refreshDayAvailableDefault();
                refreshDaysAvailable();
                await loadDaysAvailableAndDefault();
              }
              await loadHoursAvailable();
            } else {
              if (
                filterSearchSelected.specialitySelected.value !== "" ||
                filterSearchSelected.professionalSelected.value !== ""
              ) {
                resetDayDefaultAvailable();
                refreshDayAvailableDefault();
                refreshDaysAvailable();
                await loadDaysAvailableAndDefault();
                //resetHoursAvailable();
                // refreshHours();
                // await loadHoursAvailable()
              }
            }
          }
        }

        setValueAgendamientoInconcluso({
          sueCorrel:
            filterSearchSelected.sucursalSelected.sue_correl?.toString(),
          empCodigo:
            filterSearchSelected.sucursalSelected.emp_codigo?.toString(),
          espCodigo: filterSearchSelected.specialitySelected.code?.toString(),
          tapTipo: filterSearchSelected.modalidadSelected.tipo?.toString(),
          exaCorrel:
            filterSearchSelected.procedimientoSelected.code?.toString(),
          aseCorrel: filterSearchSelected.servicioSelected.code?.toString(),
          isaCodigo: filterSearchSelected.covenantSelected.code?.toString(),
        });
      } finally {
        setShowModalEditFilters(false);
        setLoading(false);
      }
    }, 0);
  };

  const eventGA = () => {
    let especialidad = filterSearchSelected.specialitySelected.value;
    especialidad = especialidad != "" ? `Especialidad: ${especialidad}` : "";
    let profesional = filterSearchSelected.professionalSelected.value;
    profesional = profesional != "" ? `| Profesional: ${profesional}` : "";
    let prevision = filterSearchSelected.covenantSelected.value;
    prevision = prevision != "" ? `| Previsión: ${prevision}` : "";
    ReactGA.event({
      category: "Buscar",
      action: `${especialidad} ${profesional} ${prevision}`,
    });
  };

  return (
    <div>
      <BootstrapDialog
        disableEscapeKeyDown
        fullWidth
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={showModalEditFilters}
      >
        <ModalTitleCustom id="customized-dialog-title">
          Reserva de hora
        </ModalTitleCustom>
        <DialogContent style={{ paddingTop: 16 }}>
          <Typography variant="h5" mb={3}>
            Busque especialidad o nombre de especialista
          </Typography>
          <FormSearch />

          <Grid
            item
            xs={12}
            md={12}
            display={"flex"}
            justifyContent={"center"}
            mt={2}
          >
            {isEmptyFilters() ? (
              <AlertCustom
                variant="outlined"
                severity="warning"
                message="Debe seleccionar al menos una especialidad y/o prestador"
                style={{
                  marginBottom: 15,
                  backgroundColor: yellow[100],
                  width: "100%",
                }}
              />
            ) : null}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Stack
            width={"100%"}
            display={"flex"}
            justifyContent={"flex-end"}
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 1, sm: 2, md: 2 }}
          >
            <ButtonCustom
              loading={loading}
              disabled={isEmptyFilters() ? true : false}
              color="secondary"
              autoFocus
              onClick={handleEditFilters}
              text="BUSCAR HORAS"
              icon={<Search />}
            />
            <ButtonCustom
              disabled={isChangeFormSearch}
              color="default"
              autoFocus
              onClick={() => {
                setShowModalEditFilters(false);
              }}
              text="Cancelar"
              icon={<Close />}
            />
          </Stack>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
